import React, {PropTypes} from 'react';
import {reduxForm} from 'redux-form';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import scrollToFirstError from '../actions';
import { permissionsFormName } from './constants';
import ManagersPanelContainer from './ManagersPanelContainer.jsx';
import AdministratorsPanelContainer from './AdministratorsPanelContainer.jsx';

const PermissionsForm = () => (
  <div className="flex center animated fadeIn">
    <form
      className="col-xs-12 col-md-10 col-lg-8">

      <ErrorListContainer />

      <div className="panel-primary">
        <ManagersPanelContainer />
      </div>

      <div className="panel-primary">
        <AdministratorsPanelContainer />
      </div>

    </form>
  </div>
);

PermissionsForm.propTypes = {
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired, 
  submitting: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool
};

export default reduxForm({
  form: permissionsFormName,
  onSubmitFail: (errors) => scrollToFirstError(errors)
})(PermissionsForm);



// WEBPACK FOOTER //
// ./src/features/tournament/permissions/PermissionsForm.jsx